import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import "./PageTransition.css";

interface PageTransitionProps {
  children: React.ReactNode;
}

const PageTransition: React.FC<PageTransitionProps> = ({ children }) => {
  const location = useLocation();
  const [shouldAnimate, setShouldAnimate] = useState(false);

  // 페이지 변경 시마다 애니메이션 트리거
  useEffect(() => {
    // 초기 로드 시에도 animate 상태를 true로 설정
    setShouldAnimate(true);

    // 컴포넌트가 언마운트될 때 cleanup
    return () => {
      setShouldAnimate(false);
    };
  }, [location.pathname]); // location.pathname이 변경될 때마다 실행

  return (
    <div className="page-transition-container">
      <div
        key={location.pathname}
        className={`page-transition ${shouldAnimate ? "fadeIn" : ""}`}
      >
        {children}
      </div>
    </div>
  );
};

export default PageTransition;
